import React from "react";
import {Warning} from "@material-ui/icons";

export function PriorityIndicator(props: { priority: number }) {
  const getColor = (priority: number) => {
    switch (priority) {
      case 1:
        return "red";
      case 2:
        return "#FFA500";
      case 3:
        return "#f6e309";
      default:
        return "gray";
    }
  }

  const getTextColor = (priority: number) => {
    switch (priority) {
      case 1:
        return "white";
      case 2:
        return "white";
      case 3:
        return "grey";
      default:
        return "black";
    }
  }

  const getText = (priority: number) => {
    switch (priority) {
      case 1:
      case 2:
      case 3:
        return `Priority ${priority}`;
      case 4:
        return "Note";
      default:
        return "";
    }
  }

  const style = {
    width: '80px',
    // height: '15px',
    borderRadius: '5px',
    backgroundColor: getColor(props.priority),
    color: getTextColor(props.priority),
    display: 'inline-block'
  };


  if (props.priority == 0) return null;

  return <span style={style} title={getText(props.priority)}>
    <Warning style={{verticalAlign: "middle", marginLeft: 5, padding: 0, marginTop: 0, fontSize: 16}}/>
    <span style={{fontSize: 12, fontWeight: "bolder"}}>
    {getText(props.priority)}
    </span>
    </span>;
}